var Menu = {};

//--------------
// Variables
//--------------
Menu.MenuItem = '.js-menu-item';
Menu.SubmenuPanel = '.js-submenu-panel';
Menu.SubmenuLink = '.js-submenu-link';
Menu.activeClass = 'is-active';
Menu.menuOpenedClass = 'is-menu-opened';
Menu.submenuOpenedClass = 'is-submenu-opened';

Menu.lastScrollTop = $(window).scrollTop();
Menu.direction = 'start';
Menu.opacity = false;

//--------------
// Functions
//--------------

/**
 * Show Desktop Menu
 * @return {[type]} [description]
 */
Menu.ShowDesktopMenu = function(element){
	if($(window).width() > 991) {
		if(element.find(Menu.SubmenuPanel).length > 0){

			element.addClass(Menu.activeClass);
			$(App.Header).addClass(Menu.menuOpenedClass);
		}
	}
}

/**
 * Hide Desktop Menu
 * @return {[type]} [description]
 */
Menu.HideDesktopMenu = function(element){
	if($(window).width() > 991) {
		element.removeClass(Menu.activeClass);
		$(App.Header).removeClass(Menu.menuOpenedClass);
	}
}

/**
 * ToucheventsMenu
 * @return {[type]} [description]
 */
Menu.ToucheventsMenu = function(element, event){
	if(($(window).width() > 991 && $('html').hasClass('touchevents')) || $(window).width() < 992) {
	  	// No click on parent links
	  	if(($(event.target).hasClass('menu__link') || $(event.target).hasClass('arrow-right')) && element.closest(Menu.MenuItem).find(Menu.SubmenuPanel).length > 0) {
	  		event.preventDefault();
	  	}

   		// Display Submenu
		if(element.closest(Menu.MenuItem).find(Menu.SubmenuPanel).length > 0){

			// Tablet Landscape
			if($(window).width() > 991) {

				if(!$(App.Header).hasClass(Menu.menuOpenedClass)) {
					$(Menu.MenuItem).removeClass(Menu.activeClass);
					element.closest(Menu.MenuItem).addClass(Menu.activeClass);
					$(App.Header).addClass(Menu.menuOpenedClass + ' ' + Menu.submenuOpenedClass);
				} else {
					if(element.closest(Menu.MenuItem).hasClass(Menu.activeClass)){

						$(Menu.MenuItem).removeClass(Menu.activeClass);
						$(App.Header).removeClass(Menu.menuOpenedClass + ' ' + Menu.submenuOpenedClass);
					} else {
						$(Menu.MenuItem).removeClass(Menu.activeClass);
						element.closest(Menu.MenuItem).addClass(Menu.activeClass);
					}
				}
			} else {
				element.closest(Menu.MenuItem).addClass(Menu.activeClass);
				$(App.Header).addClass(Menu.menuOpenedClass + ' ' + Menu.submenuOpenedClass);
			}
		}
	}
}

/**
 * Close Menu
 * @return {[type]} [description]
 */
Menu.CloseMenu = function(){
	$(Menu.MenuItem).removeClass(Menu.activeClass);
	$(App.Header).removeClass(Menu.menuOpenedClass + ' ' + Menu.submenuOpenedClass);
}

/**
 * Show Desktop Submenu
 * @return {[type]} [description]
 */
Menu.ShowDesktopSubmenu = function(element){
	$(Menu.SubmenuLink).addClass('is-link');
	element.addClass('is-hover');
}

/**
 * Hide Desktop Submenu
 * @return {[type]} [description]
 */
Menu.HideDesktopSubmenu = function(){
	$(Menu.SubmenuLink).removeClass('is-link is-hover');
}

/**
 * Menu Back Button
 * @return {[type]} [description]
 */
Menu.MenuBack = function(element){
	if(element.closest(App.Header).hasClass(Menu.submenuOpenedClass)) {
		// Hide Submenu
		$(Menu.MenuItem).removeClass(Menu.activeClass);
		$(App.Header).removeClass(Menu.submenuOpenedClass);
	} else {
		// Hide Menu
		$(App.Header).removeClass(Menu.menuOpenedClass);
	}
}

/**
 * Toogle Menu Button
 * @return {[type]} [description]
 */
Menu.ToggleMenu = function(){
	$(App.Header).toggleClass(Menu.menuOpenedClass);

	// Close Submenu
	if($(App.Header).hasClass(Menu.submenuOpenedClass)) {
		$(App.Header).removeClass(Menu.submenuOpenedClass);
	}

	// Close Menu
	if($(Menu.MenuItem).hasClass(Menu.activeClass)) {
		$(Menu.MenuItem).removeClass(Menu.activeClass);
	}
}

/**
 * Display Menu on scroll
 * @return {[type]} [description]
 */
Menu.MenuOnScroll = function(){
	// Fix Menu if scrollTop > window height
	if(Menu.position > App.$windowHeight && !Menu.opacity) {
		$(App.Header).addClass('is-black-header op-0');

		setTimeout(function(){
			$(App.Header).addClass('is-fixed');
			$(App.Header).removeClass('op-0');
		}, 400);

		Menu.opacity = true;
	}

	// Reinit menu if scrollTop = 0
	if(Menu.position == 0) {
		$(App.Header).removeClass('is-fixed');
		$(App.Header +':not(.js-black-header)').removeClass('is-black-header');

		Menu.opacity = false;
	}

	// Display and Hide Menu if scorllTop < window height
	if(Menu.position > App.$windowHeight && !$(App.Header).hasClass(Menu.menuOpenedClass)) {
		if ((Menu.position < Menu.lastScrollTop && Menu.direction == 'up') || (Menu.position < Menu.lastScrollTop && Menu.direction == 'start')){
			$(App.Header).stop().slideDown();

			Menu.direction = 'down';
		} else if ((Menu.position > Menu.lastScrollTop && Menu.direction == 'down') || (Menu.position > Menu.lastScrollTop && Menu.direction == 'start')){
			$(App.Header).stop().slideUp();

			Menu.direction = 'up';
		}

		Menu.lastScrollTop = Menu.position;
	}
}


//--------------
// Execution
//--------------

//-- Desktop Menu
$('.no-touchevents '+ Menu.MenuItem).hover(function(){
	// Show Menu
	Menu.ShowDesktopMenu($(this));
}, function(){
	// Hide Menu
  Menu.HideDesktopMenu($(this));
});

//-- Touchevents Menu
$('.js-menu-item > .menu__link').on('click', function(event){
	Menu.ToucheventsMenu($(this), event);
});

// Close menu
$('.js-close-menu').on('click', function(){
	Menu.CloseMenu();
});

//-- No touchevents Submenu
$('.no-touchevents '+ Menu.SubmenuLink).hover(function(){
 // Display Submenu
	Menu.ShowDesktopSubmenu($(this));
}, function(){
	// Hide Submenu
	Menu.HideDesktopSubmenu();
});

//-- Menu Back Button
$('.js-menu-back').on('click', function(){
	Menu.MenuBack($(this));
});

//-- Toggle Menu button
$('.js-toggle-menu').on('click', function(){
	Menu.ToggleMenu();
});

//-- Show fixed menu when scroll up
$(window).scroll(function(event){
	Menu.position = $(this).scrollTop();

	Menu.MenuOnScroll();
});

module.exports = Menu;
